import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import GroupBuy from '../../entities/groupBuy';

interface GroupBuyState extends ListState<GroupBuy>{
    editGroupBuy:GroupBuy
}
class GroupBuyMutations extends ListMutations<GroupBuy>{

}
class GroupBuyModule extends ListModule<GroupBuyState,any,GroupBuy>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<GroupBuy>(),
        loading:false,
        editGroupBuy:new GroupBuy()
    }
    actions={
        async getAll(context:ActionContext<GroupBuyState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GroupBuy/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<GroupBuy>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<GroupBuyState,any>,payload:any){
            await Ajax.post('/api/services/app/GroupBuy/Create',payload.data);
        },
        async createWithImages(context:ActionContext<GroupBuyState,any>,payload:any){
            await Ajax.post('/api/services/app/GroupBuy/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<GroupBuyState,any>,payload:any){
            await Ajax.put('/api/services/app/GroupBuy/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<GroupBuyState,any>,payload:any){
            await Ajax.put('/api/services/app/GroupBuy/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<GroupBuyState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/GroupBuy/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<GroupBuyState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/GroupBuy/Get?Id='+payload.id);
            return reponse.data.result as GroupBuy;
        },
        async confirmPrice(context:ActionContext<GroupBuyState,any>,payload:any){
            let reponse=await Ajax.post('/api/services/app/GroupBuy/ConfirmPrice',payload.data);
            return reponse
        },
        async setPriceDiff(context:ActionContext<GroupBuyState,any>,payload:any){
            let reponse=await Ajax.post('/api/services/app/GroupBuy/SetPriceDiff',payload.data);
            return reponse
        }
    };
    mutations={
        setCurrentPage(state:GroupBuyState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GroupBuyState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:GroupBuyState,groupBuy:GroupBuy){
            state.editGroupBuy=groupBuy;
        },
        changeLoading(state:GroupBuyState,pass:boolean){
            state.loading = pass;
        }
    }
}
const groupBuyModule=new GroupBuyModule();
export default groupBuyModule;